// 30 minutes session on backend
// 10 minutes before logout show modal
export const LOGOUT_TIMER_TIMEOUT = 10 * 60 * 1000 - 10 * 1000; // - 10 seconds lag, when tab is inactive
// 15 in total to be allowed to call logout endpoint
export const LOGOUT_TIMEOUT = 5 * 60 * 1000 - 10 * 1000; // - 10 seconds lag, when tab is inactive